import { render, staticRenderFns } from "./BonusCard.vue?vue&type=template&id=73237f3f&scoped=true"
import script from "./BonusCard.vue?vue&type=script&lang=ts"
export * from "./BonusCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73237f3f",
  null
  
)

export default component.exports